var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-checkbox",class:{
    checked: _vm.modelValue === true,
    indeterminate: _vm.modelValue === 'indeterminate',
  },on:{"click":_vm.toggle}},[_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }